import { combineReducers } from 'redux-immutable';
import {reducre as deviceTypeListReducer} from '../components/DeviceTypeList/store/index.js';
import {reducre as datePickerListReducer} from '../components/datePickerList/store/index.js';
const defaultCombine = combineReducers({
  deviceTypeList:deviceTypeListReducer,
  datePickerList:datePickerListReducer
})

export default defaultCombine